export default "__VITE_ASSET__DvV3wHbR__"